import { render } from "./Top.vue?vue&type=template&id=0aaf4b20"
import script from "./Top.vue?vue&type=script&setup=true&lang=js"
export * from "./Top.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/top/Top.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aaf4b20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aaf4b20', __exports__)) {
    console.log('reload')
    api.reload('0aaf4b20', __exports__)
  }
  
  module.hot.accept("./Top.vue?vue&type=template&id=0aaf4b20", () => {
    console.log('re-render')
    api.rerender('0aaf4b20', render)
  })

}


export default __exports__